import React from 'react';
import { Link } from 'react-router-dom';

interface AuthLinkProps {
  text: string;
  linkText: string;
  linkTo: string;
}

const AuthLink: React.FC<AuthLinkProps> = ({ text, linkText, linkTo }) => {
  return (
    <div className="authLinkContainer">
      <p>
        {text}{" "}
        <Link to={linkTo} className="authLink">
          {linkText}
        </Link>
      </p>
    </div>
  );
};

export default AuthLink;